import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=9e748efa&scoped=true"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=9e748efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e748efa",
  null
  
)

export default component.exports